import { useState, useEffect, useCallback } from 'react';
import campaignService from '../../services/campaign.service';

export function useCampaign(campaignId) {
    const [campaign, setCampaign] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCampaign = useCallback(() => {
        if (!campaignId) {
            setIsLoading(false);
            setError('Campaign id is missing.');
            return;
        }

        setIsLoading(true);
        setError(null);

        return campaignService
            .getCampaignById(campaignId)
            .then((res) => setCampaign(res.data))
            .catch(() => {
                setCampaign(null);
                setError('Failed to load campaign. Please try again.');
            })
            .finally(() => setIsLoading(false));
    }, [campaignId]);

    useEffect(() => {
        fetchCampaign();
    }, [fetchCampaign]);

    return { campaign, isLoading, error, refetch: fetchCampaign };
}
